import { LinearProgress } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { TableSet } from "components/tableSetExplorer/TableSet";
import { useSolutionKey } from "features/solution";
import {
  QueryInputDataTables,
  QueryInputDataVariables
} from "features/use-case";
import { isEmpty } from "lodash";
import React from "react";
import { createDataKey } from "utils/dataKey";
import { useCalculationInputData, useQueryInputSchema } from "./inputDataHooks";

interface InputDataTableSetProps {
  useCaseKey: string;
  useCaseVersion: string;
  dataId?: string;
}

const useStyles = makeStyles(theme => ({
  tableSetWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    border: `solid 1px rgba(0,0,0,0.12)`
  },
  backgroundColor: { backgroundColor: theme.palette.primary.main }
}));

const InputDataTableSet: React.FC<InputDataTableSetProps> = ({
  useCaseKey,
  useCaseVersion,
  dataId
}) => {
  const solutionKey = useSolutionKey();

  const dataKey = createDataKey({
    solutionKey,
    useCaseKey,
    version: useCaseVersion,
    dataId
  });
  const { tableSetWrapper, backgroundColor } = useStyles({});
  const {
    data: { inputSchema, inputColumnDefs, loadingData }
  } = useQueryInputSchema({
    solutionKey,
    useCaseKey,
    useCaseVersion,
    keys: dataKey ? [dataKey] : []
  });
  const { loadInputData } = useCalculationInputData();

  return (
    <div className={tableSetWrapper}>
      {isEmpty(inputSchema) || loadingData ? (
        <LinearProgress />
      ) : dataKey ? (
        <TableSet<QueryInputDataVariables, QueryInputDataTables>
          tablesSchema={inputSchema}
          dataKey={dataKey}
          useCaseVersion={useCaseVersion}
          useCaseKey={useCaseKey}
          loadData={loadInputData}
          columnDefs={schemaName => inputColumnDefs(schemaName) ?? []}
          backgroundColor={backgroundColor}
        />
      ) : null}
    </div>
  );
};

export default InputDataTableSet;
